import {RewardsState} from '../../reducers/fortnite-game/rewards.reducer';

export const getRewardsTop10GamesState = (state): RewardsState => {
    return state.get('rewardsTop10Games').toJS();
};
